export async function downloadProductDetailAppointmentUseCase(appointment_id, appointmentRepostitory) {
    const result = await appointmentRepostitory.download_product_detail_report(appointment_id);

    const entity = new appointmentRepostitory.model_report(result)
    
    if (!entity.isValid()) {
      throw new Error("Reporte inválido");
    }

    return result;
}